import {Col, Row} from "react-bootstrap";
import PropTypes from "prop-types";

export function Section(props) {
    const {children, title, style, className} = props;
    return <Row className={"g-0 " + (className ? className : "")} style={style ? style : {}}>
        {title ? <Col className={"text-center"} xs={12}>
            <h5>{title}</h5>
        </Col> : <></>}
        {children}
    </Row>
}


Section.propTypes = {
    children: PropTypes.any,
    title: PropTypes.string,
    style: PropTypes.any,
    className: PropTypes.string
}